import { render, staticRenderFns } from "./DashboardCardItem.vue?vue&type=template&id=631696fa&scoped=true"
import script from "./DashboardCardItem.vue?vue&type=script&lang=js"
export * from "./DashboardCardItem.vue?vue&type=script&lang=js"
import style0 from "./DashboardCardItem.vue?vue&type=style&index=0&id=631696fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631696fa",
  null
  
)

export default component.exports